"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Span = exports.Header = exports.HeaderContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.HeaderContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;

  .Polaris-Button {
    height: 36px;
  }
`;
exports.Header = styled_components_1.default.div `
  font: bold ${config_1.fontSizes.large} ${config_1.fontFamilies.primary};
  margin-bottom: 18px;
`;
exports.Span = styled_components_1.default.span `
  font-weight: 500;
`;
